/* EPA — interacciones del tema (megamenú, menú móvil, carrusel, pestañas) */
(() => {
  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');

  /* ---------- Megamenú ---------- */
  function initMega(root = document) {
    const items = root.querySelectorAll('[data-epa-mega]');
    if (!items.length) return;
    let openItem = null;
    let closeTimer = null;

    const open = (item) => {
      if (openItem === item) return;
      if (openItem) close(openItem);
      const btn = item.querySelector('.epa-nav__trigger');
      const panel = item.querySelector('.epa-mega');
      panel.hidden = false;
      requestAnimationFrame(() => item.classList.add('is-open'));
      btn.setAttribute('aria-expanded', 'true');
      openItem = item;
    };
    const close = (item) => {
      const btn = item.querySelector('.epa-nav__trigger');
      const panel = item.querySelector('.epa-mega');
      item.classList.remove('is-open');
      btn.setAttribute('aria-expanded', 'false');
      panel.hidden = true;
      if (openItem === item) openItem = null;
    };

    items.forEach((item) => {
      const btn = item.querySelector('.epa-nav__trigger');
      btn.addEventListener('click', () => (openItem === item ? close(item) : open(item)));
      item.addEventListener('mouseenter', () => {
        if (!desktop.matches) return;
        clearTimeout(closeTimer);
        open(item);
      });
      item.addEventListener('mouseleave', () => {
        if (!desktop.matches) return;
        closeTimer = setTimeout(() => close(item), 160);
      });
      item.addEventListener('focusout', (e) => {
        if (!item.contains(e.relatedTarget)) close(item);
      });
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && openItem) {
        const btn = openItem.querySelector('.epa-nav__trigger');
        close(openItem);
        btn.focus();
      }
    });
    document.addEventListener('click', (e) => {
      if (openItem && !openItem.contains(e.target)) close(openItem);
    });
  }

  /* ---------- Menú móvil ---------- */
  function initDrawer(root = document) {
    const drawer = root.querySelector('[data-epa-drawer]');
    if (!drawer) return;
    const summary = drawer.querySelector('summary');
    drawer.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('epa-lock', drawer.open);
      if (drawer.open) drawer.querySelector('.epa-drawer__panel a, .epa-drawer__panel summary')?.focus();
    });
    drawer.querySelectorAll('[data-epa-drawer-close]').forEach((el) =>
      el.addEventListener('click', () => {
        drawer.open = false;
        summary.focus();
      })
    );
    drawer.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        drawer.open = false;
        summary.focus();
      }
    });
  }

  /* ---------- Carrusel hero ---------- */
  function initSlider(root = document) {
    root.querySelectorAll('[data-epa-slider]').forEach((slider) => {
      const slides = [...slider.querySelectorAll('[data-epa-slide]')];
      const dots = [...slider.querySelectorAll('[data-epa-dot]')];
      const pauseBtn = slider.querySelector('[data-epa-pause]');
      if (slides.length < 2) return;
      let index = 0;
      let timer = null;
      let paused = slider.dataset.autoplay !== 'true' || reduceMotion.matches;
      const speed = (parseInt(slider.dataset.speed, 10) || 6) * 1000;

      const go = (i) => {
        index = (i + slides.length) % slides.length;
        slides.forEach((s, n) => {
          const active = n === index;
          s.classList.toggle('is-active', active);
          s.setAttribute('aria-hidden', active ? 'false' : 'true');
          s.querySelectorAll('a.epa-btn').forEach((a) => (active ? a.removeAttribute('tabindex') : a.setAttribute('tabindex', '-1')));
        });
        dots.forEach((d, n) => {
          d.classList.toggle('is-active', n === index);
          n === index ? d.setAttribute('aria-current', 'true') : d.removeAttribute('aria-current');
        });
      };
      const stop = () => clearInterval(timer);
      const start = () => {
        stop();
        if (!paused) timer = setInterval(() => go(index + 1), speed);
      };
      const setPaused = (p) => {
        paused = p;
        slider.classList.toggle('is-paused', paused);
        if (pauseBtn) pauseBtn.setAttribute('aria-label', paused ? 'Reproducir carrusel' : 'Pausar carrusel');
        start();
      };

      slider.querySelector('[data-epa-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
      slider.querySelector('[data-epa-next]')?.addEventListener('click', () => { go(index + 1); start(); });
      dots.forEach((d) => d.addEventListener('click', () => { go(parseInt(d.dataset.epaDot, 10)); start(); }));
      pauseBtn?.addEventListener('click', () => setPaused(!paused));
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', (e) => { if (!slider.contains(e.relatedTarget)) start(); });

      // Deslizar en celular
      let x0 = null;
      slider.addEventListener('touchstart', (e) => { x0 = e.touches[0].clientX; stop(); }, { passive: true });
      slider.addEventListener('touchend', (e) => {
        if (x0 === null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) go(index + (dx < 0 ? 1 : -1));
        x0 = null;
        start();
      });

      setPaused(paused);
    });
  }

  /* ---------- Pestañas ---------- */
  function initTabs(root = document) {
    root.querySelectorAll('[data-epa-tabs]').forEach((wrap) => {
      const tabs = [...wrap.querySelectorAll('[role="tab"]')];
      const select = (tab, focus) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      };
      tabs.forEach((t, i) => {
        t.addEventListener('click', () => select(t));
        t.addEventListener('keydown', (e) => {
          let n = null;
          if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
          if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
          if (e.key === 'Home') n = 0;
          if (e.key === 'End') n = tabs.length - 1;
          if (n !== null) { e.preventDefault(); select(tabs[n], true); }
        });
      });
    });
  }

  /* ---------- Modo claro / oscuro ---------- */
  function initTheme(root = document) {
    const html = document.documentElement;
    const sync = () => {
      const dark = html.getAttribute('data-theme') === 'dark';
      root.querySelectorAll('[data-epa-theme-toggle]').forEach((b) => {
        b.setAttribute('aria-pressed', dark);
        b.setAttribute('aria-label', dark ? 'Activar modo claro' : 'Activar modo oscuro');
      });
    };
    root.querySelectorAll('[data-epa-theme-toggle]').forEach((btn) => {
      if (btn.dataset.bound) return;
      btn.dataset.bound = '1';
      btn.addEventListener('click', () => {
        const next = html.getAttribute('data-theme') === 'dark' ? 'light' : 'dark';
        if (!reduceMotion.matches) {
          html.classList.add('epa-theme-switching');
          setTimeout(() => html.classList.remove('epa-theme-switching'), 350);
        }
        html.setAttribute('data-theme', next);
        try { localStorage.setItem('epa-theme', next); } catch (e) {}
        sync();
      });
    });
    sync();
  }

  /* ---------- Ver más productos (catálogo con ofertas primero) ---------- */
  function initLoadMore() {
    if (document.documentElement.dataset.epaMore) return;
    document.documentElement.dataset.epaMore = '1';
    document.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-epa-more-btn]');
      if (!btn) return;
      const step = parseInt(btn.dataset.step, 10) || 24;
      const total = parseInt(btn.dataset.total, 10) || 0;
      const count = btn.parentElement.querySelector('[data-epa-more-count]');
      const hidden = [...document.querySelectorAll('#product-grid [data-epa-more][hidden]')];
      hidden.slice(0, step).forEach((li) => li.removeAttribute('hidden'));
      const left = document.querySelectorAll('#product-grid [data-epa-more][hidden]').length;
      if (count) count.textContent = `Mostrando ${total - left} de ${total} productos`;
      if (!left) btn.parentElement.remove();
      hidden[0]?.querySelector('a')?.focus({ preventScroll: true });
    });
  }

  /* ---------- Anuncio 10% (solo para quien no se ha suscrito) ---------- */
  function initPromo() {
    const promo = document.querySelector('[data-epa-promo]');
    const store = {
      get: (k) => { try { return localStorage.getItem(k); } catch (e) { return null; } },
      set: (k, v) => { try { localStorage.setItem(k, v); } catch (e) {} },
    };
    // Si el formulario del newsletter acaba de enviarse con éxito, recordar que ya se suscribió
    if (document.querySelector('.epa-news__msg[role="status"]') || /customer_posted=true/.test(location.search)) {
      store.set('epa-subscribed', '1');
    }
    if (!promo || promo.dataset.bound) return;
    promo.dataset.bound = '1';
    if (store.get('epa-subscribed')) { promo.remove(); return; }
    promo.hidden = false;
    requestAnimationFrame(() => promo.classList.add('is-in'));
    promo.querySelector('[data-epa-promo-link]').addEventListener('click', (e) => {
      const target = document.getElementById('epa-newsletter');
      if (!target) return; // en otras páginas, navega a la portada
      e.preventDefault();
      target.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
      const input = target.querySelector('input[type="email"]');
      setTimeout(() => input && input.focus({ preventScroll: true }), reduceMotion.matches ? 0 : 700);
      target.classList.add('is-highlight');
      setTimeout(() => target.classList.remove('is-highlight'), 1800);
    });
  }

  const initAll = (root) => { initPromo(); initLoadMore(root); initTheme(root); initMega(root); initDrawer(root); initSlider(root); initTabs(root); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll(document));
  else initAll(document);

  // Editor de temas
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
})();
